<template>
    <el-header :class="['header-box flex flex-space-between flex-align-center',homeClass]">
        <!--  logo  -->
        <div>
            <img v-if="homeClass === 'home-box'" src="@/assets/imgs/logo.png">
            <img v-else src="@/assets/imgs/logo2.png">
        </div>
        <div class="menu-lists flex flex-align-center">
            <ul class="flex flex-align-center">
                <li
                    class="cursor-pointer"
                    :class="{checked: item.includePah.includes(selectPath)}"
                    v-for="(item,i) in list"
                    @click="handleRouter(item)"
                    :key="i">{{ item.name }}
                </li>
            </ul>
        </div>
        <div v-if="homeClass === 'home-box'" class="flex flex-align-center">
            <div class="wechat-box cursor-pointer" @click="handleWx()">
                <img src="@/assets/imgs/update/wx-logo.jpg">
                微信小程序
            </div>
            <div class="xcx-box cursor-pointer" @click="gotoDsbk()">大圣文化专题网 <i class="logo-icon">热门</i></div>
            <img class="search-icon cursor-pointer" @click="handleSearch()" src="/image/search.png">
        </div>
        <!--   微信小程序的弹窗     -->
        <Dialog :dialog-visible.sync="dialog" title="微信小程序"  :show-submit-btn="false">
            <img class="img-box" src="@/assets/imgs/update/mini.jpg">
        </Dialog>

    </el-header>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';

import { menuLists } from '@/util/const';
import { useRoute, useRouter } from 'vue-router/composables';
import QRcode from 'qrcodejs2';
import Dialog from '@/components/dialog.vue';


const route = useRoute();
const router = useRouter();


let selectPath = ref(null);
const list = menuLists;
let dialog = ref(false);
let code = null;
const handleRouter = (item) => {
    selectPath.value = item.path;
    router.push(item.path);
};

// 打开小程序二维码
const handleWx = () => {
    dialog.value = true;
    // if(code) return
    // setTimeout(()=>{
    //     code = new QRcode('qrCode', {
    //         width: 200, // 生成二维码宽度
    //         height: 200, // 生成二维码高度
    //         text: 'url地址', // 二维码地址或文本，如果是网址扫码后会跳转网址
    //         colorDark: '#000',
    //         colorLight: '#fff'
    //     })
    // },10)
};

const gotoDsbk = () => {
    window.open('https://dasheng.scxbwg.cn/', '_blank');
};

const handleSearch = () => {
    router.push('/articleSearch');
};

watch(() => route.path, val => {

    selectPath.value = val;
});

const homeClass = computed(() => {
    return route.name === 'Home' ? 'home-box' : 'page-box';
});


onMounted(() => {
    selectPath.value = route.path;

});

</script>

<style lang="scss" scoped>
.header-box {
    height: 109px !important;
    background: #ffffff;
    position: relative;
    z-index: 9;

    img {
        width: 349px;
        height: 78px;
    }

    .menu-lists {
        li {
            width: 85px;
            height: 100%;
            text-align: center;
            line-height: 109px;
            color: #efe0e2;
            font-size: 20px;

            &:hover {
                background: #8b3527;
            }

            &.checked {
                background: #8b3527;
            }

        }
    }
    .wechat-box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #fff;
        margin-left: 30px;
        img {
            margin-right: 10px;
            width: 30px;
            height: 30px;
        }
    }
    .xcx-box {
        color: #ffffff;
        font-size: 16px;
        width: 180px;
        height: 41px;
        border: 1px solid;
        border-color: #ffffff;
        border-radius: 39px;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        margin-left: 30px;
        position: relative;

        i {
            position: absolute;
            top: -12px;
            background: red;
            width: 31px;
            height: 15px;
            border-radius: 15px;
            display: block;
            color: #ffffff;
            font-size: 11px;
            right: 0;
            line-height: 14px;
            font-style: normal;
        }
    }
    .search-icon {
        width:95px;
        height:41px;
        margin-left: 30px;
    }
}
.img-box{
    width: 300px;
    height: 300px;
}
.page-box{
    justify-content: center !important;

    img{
        margin-right: 62px;
    }

    li{
        font-family:Arial;
        color:#1e1e1e !important;
        position: relative;

        &:hover{
            background: #ffffff !important;
        }
        &.checked {
            background: #ffffff !important;
            color:#066a76 !important;


            &:after{
                content: '';
                position: absolute;
                bottom: 25%;
                left: 0;
                right: 0;
                margin: auto;
                width: 52px;
                height: 4px;
                background: #066a76;
            }
        }
    }
}
.home-box{
    background: transparent !important;

    li{
        font-family:Arial;
        position: relative;

        &:hover{
            background: transparent !important;
        }
        &.checked {
            background: transparent !important;
            color:#066a76 !important;


            &:after{
                content: '';
                position: absolute;
                bottom: 25%;
                left: 0;
                right: 0;
                margin: auto;
                width: 52px;
                height: 4px;
                background: #066a76;
            }
        }
    }
}
</style>
